import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Button,
  Alert,
  Spinner,
  Badge,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function Agenttable() {
  var history = useHistory();
  const sort = 25;
  const activePag = useRef(0);
  const [vehicleType, setVehicleType] = useState("");
  const [searchItem, setSearchItem] = useState("Name");
  const [searchVehicleType, setSearchVehicleType] = useState("Auto");
  const [stateForSearch, setStateForSearch] = useState([]);
  const [pincodes, setpincodes] = useState([]);
  const [data, setData] = useState([]);
  const [forSearch, setForSearch] = useState([]);
  const [geoPincodes, setGeoPincodes] = useState([]);
  const [riders, setRiders] = useState([]);
  const [riderId, setRiderId] = useState("");
  const [riderdata, setriderdata] = useState("");
  const [pincode, setpincode] = useState([]);
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [online, setOnline] = useState(false);
  const [offline, setOffline] = useState(false);
  const [view, setView] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [checkedAll, setCheckedAll] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  const searchObject = ["Name", "Phone Number", "OnBoard ID", "Vehicle Type"];
  const VehicleTypes = [
    "Auto",
    "SUV/MUV",
    "Sedan",
    "Hatch Back",
    "Tata Ace",
    "PickUp 8ft",
    "Tata 407",
  ];
  function getData(length) {
    axios
      .get(Baseurl.baseurl + `/rider/get-all-rider/${length}`)
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);
          setRiders(
            (oldArray) => oldArray.concat(res.data.data),
            () => {}
          );
          setData(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("No More Data", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
      });
  }

  useEffect(() => {
    getData(riders.length);
  }, []);
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };
  const handleShow = (geofence, id, geoId) => {
    setCheckedAll(false);
    if (geofence == "vgeo") {
      setriderdata("");
      axios
        .get(Baseurl.baseurl + `/go-geofence/get-geofence-by-id/${geoId}`)
        .then((res) => {
          setpincode(res.data.pincodes);
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      //setAllPincodes(pincode.map(String));
      setShow(true);
    } else {
      setShow(true);
      setriderdata(id);
    }
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const blockrider = (id) => {
    axios
      .put(`${Baseurl.baseurl}/rider/block-rider/${riderdata}`)
      .then((response) => {
        handleClose();
        if (response.data.status) {
          swal("Blocked", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        let result = riders.filter((val) => {
          if (val._id != riderdata) {
            return val;
          }
        });
        setRiders(result);
        setData(document.querySelectorAll("#job_data tbody tr"));
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }
  function searchByVehicleType(value) {
    let searchData = {
      query: value,
    };

    axios
      .post(`${Baseurl.baseurl}/rider/get-rider-by-vehicle-type`, searchData)
      .then((res) => {
        setRiders(res.data.data);
        setData(document.querySelectorAll("#job_data tbody tr"));
      })
      .catch((err) => {});
  }
  function searchRider(value) {
    axios
      .get(`${Baseurl.baseurl}/rider/search-rider/0?query=${value}`)
      .then((res) => {
        if (res.data.status) {
          setRiders(res.data.data);
        } else {
          setRiders([]);
        }
        setData(document.querySelectorAll("#job_data tbody tr"));
      })
      .catch((err) => {});
  }
  function showUpdateGeo() {
    setView(false);
    // setshowdictpincodes1("false");
    // setshowstates("true");
    // setshowdistricts(false);
    setShow1(true);
    setShow(false);
    axios
      .get(Baseurl.baseurl + `/go-geofence/get-all-geofence`)
      .then((res) => {
        let valArr = [];
        res.data.pincodes.map((val) => {
          if (val.VehicleTypes.includes(vehicleType)) {
            valArr.push(val);
          }
        });
        setpincodes(valArr);
        setStateForSearch(valArr);
      })

      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function searchPincode(value) {
    let filteredData = [];
    forSearch.map((val) => {
      let pinString = val.toString();
      if (pinString.includes(value)) {
        filteredData.push(val);
      }
    });
    setGeoPincodes(filteredData);
  }
  const setitem = (id) => {
    axios
      .get(Baseurl.baseurl + `/go-geofence/get-geofence-by-id/${id}`)
      .then((res) => {
        setGeoPincodes(res.data.pincodes.PinCode);
        setForSearch(res.data.pincodes.PinCode);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  const setitemapi = (geoId) => {
    var Pincodes = {
      geofenceID: `${geoId}`,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-geofence/assign-geofence/${riderId}`,
        Pincodes
      )
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
        setShow1(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  function searchDist(value) {
    let filteredData = [];
    stateForSearch.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setpincodes(filteredData);
  }
  function deleteRider() {
    axios
      .delete(Baseurl.baseurl + `/rider/delete-rider-by-id/${riderId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });

          let result = riders.filter((val) => {
            if (val._id != riderId) {
              return val;
            }
          });
          setRiders(result);
          setData(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow2(false);
  }
  function getOnlineRider() {
    axios
      .get(Baseurl.baseurl + "/rider/get-rider-online")
      .then((res) => {
        if (res.data.status) {
          setRiders(res.data.riders.reverse());

          setOnline(!online);
          setOffline(false);
          setData(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("No Riders in Online", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getOfflineRider() {
    axios
      .get(Baseurl.baseurl + "/rider/get-rider-offline")
      .then((res) => {
        if (res.data.status) {
          setRiders(res.data.riders.reverse());

          setOnline(false);
          setOffline(!offline);
          setData(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("No Riders in Offline", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Body>
          <h4>Are you sure you want to delete the Rider</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteRider();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body>
          {view && (
            <div className="row">
              <div className="col-sm-8">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setView(false);
                  }}
                >
                  Back
                </button>
              </div>
              <div className="col-sm-4">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Search here..."
                  onChange={(e) => {
                    searchPincode(e.target.value);
                  }}
                />
              </div>
            </div>
          )}
          {!view && (
            <div className="row">
              <div className="col-sm-8">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setShow(true);
                    setShow1(false);
                  }}
                >
                  Back
                </button>
              </div>
              <div className="col-sm-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here..."
                  onChange={(e) => {
                    searchDist(e.target.value);
                  }}
                />
              </div>
            </div>
          )}

          <Table id="myTable" responsive>
            {!view && (
              <thead>
                <tr>
                  <th>
                    <strong>Geofence Name</strong>
                  </th>
                  <th>
                    <strong>Vehicle Types</strong>
                  </th>
                  <th>
                    <strong>View</strong>
                  </th>
                  <th>
                    <strong>Add</strong>
                  </th>
                </tr>
              </thead>
            )}

            <tbody>
              {view ? (
                <Table responsive className="table table-striped">
                  <thead>
                    <tr>
                      <th>
                        <strong>Pincodes</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {geoPincodes &&
                      geoPincodes.map((i) => (
                        <tr>
                          <td>{i}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <>
                  {pincodes &&
                    pincodes.map((val) => {
                      return (
                        <tr>
                          <td>
                            <strong>{val.Name}</strong>
                          </td>
                          <td>
                            {val.VehicleTypes.map((val) => {
                              return (
                                <div>
                                  <strong>{val}</strong>
                                </div>
                              );
                            })}
                          </td>
                          <td>
                            <Link>
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  setitem(val._id);
                                  setView(true);
                                }}
                              >
                                View
                              </button>
                            </Link>
                          </td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                setitemapi(val._id);
                              }}
                            >
                              ADD
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
      <Modal
        size={`${riderdata != "" ? "" : "lg"}`}
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          {riderdata != "" ? (
            <h4>Block Rider</h4>
          ) : (
            <h4>Geofence assigned to this user</h4>
          )}
        </Modal.Header>
        <Modal.Body>
          {riderdata != "" ? (
            <h4>Are you sure you want to block the user</h4>
          ) : (
            <>
              <table
                className="display w-100 dataTable "
                id="myTable"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  <div className="row mb-4">
                    <h4 className=" mt-2">{pincode.Name}</h4>
                    {pincode.VehicleTypes &&
                      pincode.VehicleTypes.map((val) => {
                        return (
                          <h5 className="bg-warning p-1 pl-3 pr-3 pt-1 rounded-pill ml-2 mt-1">
                            {val}
                          </h5>
                          // <Badge
                          //   className="text-center p-1 ml-2"
                          //   variant="primary badge-xs light"
                          // >
                          //   {val}
                          // </Badge>
                        );
                      })}
                    <button
                      className="btn btn-primary ml-3"
                      onClick={() => {
                        showUpdateGeo();
                      }}
                    >
                      Update
                    </button>
                  </div>
                  {/* <div>
                    <input
                      type="text"
                      className="form-control col-sm-3 mb-3"
                      placeholder="Search here..."
                      onChange={(e) => {
                        // searchRider(e.target.value);
                      }}
                    />
                  </div> */}
                  {pincode.PinCode &&
                    pincode.PinCode.map((val) => {
                      return (
                        <div className="row">
                          <tr className="ml-3 mb-3">{val}</tr>
                        </div>
                      );
                    })}
                </tbody>
              </table>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {riderdata != "" ? (
            <Button
              variant="primary"
              onClick={() => {
                blockrider();
              }}
            >
              yes
            </Button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <input
            type="text"
            className="form-control col-sm-3"
            placeholder={`search riders`}
            onChange={(e) => {
              searchRider(e.target.value);
            }}
          />

          <button
            className="btn btn-success"
            onClick={() => {
              getOnlineRider();
            }}
          >
            {online ? riders.length : "Online"}
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              getOfflineRider();
            }}
          >
            {offline ? riders.length : "Offline"}
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              setOffline(false);
              setOnline(false);
              getData(riders.length);
            }}
          >
            All
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-sm" responsive>
                <thead>
                  <tr>
                   
                    {/* <th>
                      <strong>Profile</strong>
                    </th> */}
                    <th>
                      <strong>RIDER NAME</strong>
                    </th>
                    <th>
                      <strong>Rider Id</strong>
                    </th>
                    <th>
                      <strong>Phone No.</strong>
                    </th>
                    <th>
                      <strong>status</strong>
                    </th>
                    <th>
                      <strong>Wallet</strong>
                    </th>
                    <th>
                      <strong>Vehicle</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {riders &&
                    riders.map((rider, key) => (
                      <tr key={rider._id}>
                      
                        {/* <td>
                          <div className="profile-photo">
                            <img
                              src={`${Baseurl.baseurl}/uploads/images/${rider.riderProfileImage}`}
                              className="img-fluid rounded-circle"
                              alt="profile"
                            />
                          </div>
                        </td> */}
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={rider.riderProfileImage}
                              className="rounded-lg mr-2"
                              width={40}
                              height={40}
                              alt=""
                            />{" "}
                            <span className="w-space-no">
                              {rider.riderFirstName} {rider.riderLastName}
                            </span>
                          </div>
                        </td>
                        <td>{rider._id}</td>
                        <td>{rider.riderPhone}</td>
                        <td>
                          {rider.Online ? (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-success mr-1"></i>{" "}
                              Online
                            </div>
                          ) : (
                            <div className="d-flex align-items-center">
                              <i className="fa fa-circle text-danger mr-1 "></i>
                              Offline
                            </div>
                          )}
                        </td>
                        <td>{rider.riderWallet}</td>
                        <td>{rider.RiderVehicleType.name}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `./rider-details/Rider/${rider._id}`
                                  );
                                }}
                              >
                                View
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `/view-Rider-Order/${rider._id}`
                                  );
                                }}
                              >
                                View Order
                              </Dropdown.Item>

                              {/* <Dropdown.Item
                                onClick={() => {
                                  setShow1(false);
                                  setRiderId(rider._id);
                                  handleShow(
                                    "vgeo",
                                    rider._id,
                                    rider.RiderGeoFence
                                  );
                                  setVehicleType(rider.RiderVehicleType.name);
                                }}
                              >
                                View geofence
                              </Dropdown.Item> */}
                              <Dropdown.Item
                                onClick={() => handleShow("block", rider._id)}
                              >
                                Block Rider
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow2(true);
                                  setRiderId(rider._id);
                                }}
                              >
                                Delete Rider
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                        <td>
                          <Link to={`./edit-rider/Rider/${rider._id}`}>
                            <button className="btn btn-primary">Edit</button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!riders && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero riders
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button
                  onClick={() => {
                    getData(riders.length);
                  }}
                  className="btn btn-primary ml-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Agenttable;
